export const MAP_MODALITY_COLORS = new Map([
  [ "instalação", "#3366cc" ],
  [ "comissionamento", "#dd4477" ],
  [ "preventiva padrão", "#66aa00" ],
  [ "suporte técnico", "#316395" ],
  [ "corretiva emergencial", "#b82e2e" ],
  [ "auditoria", "#3366cc" ],
  [ "as-built", "#994499" ],
  [ "start-up", "#22aa99" ],
  [ "treinamento", "#aaaa11" ],
  [ "consultoria", "#dc3912" ],
  [ "preditiva", "#109618" ],
  [ "corretiva programada", "#ff9900" ],
  [ "evolutiva", "#990099" ],
  [ "ti", "#0099c6" ],
  [ "cancelado", "#000000" ],
  [ "preventiva crítica", "#800808" ],
]);
